// extracted by mini-css-extract-plugin
export var boxItems = "_54-1";
export var boxItemsLg = "_54-2";
export var button = "_54-7";
export var buttonLg = "_54-8";
export var filterGroupBox = "_54-0";
export var icon = "_54-3";
export var iconSecondary = "_54-6";
export var iconWrapper = "_54-4";
export var iconWrapperLg = "_54-5";